
import Vue from 'vue';

export default Vue.extend({
  name: 'Help',
  props: {
    customKey: {
      type: String,
      required: true
    }
  },
  data: () => ({
    showDialog: false
  })
});
